<template>
  <div class="landingpageParagraph" :class="blue?'blueParagraph':'creamParagraph'">
    <div class="landingpageImage" :class="[imageLeft?'landingpageImageLeft':'landingpageImageRight']" :style="{ backgroundImage: 'url('+imageUrl+')' }" ></div>
    <div class="flexwrap" style="flex-direction: column;
    z-index: 10;">
    <h1 class="paragraphTitle" v-if="title !=''">{{title}}</h1>
    <div class="paragraphContent">
      <slot></slot>
    </div>

    <!--<div class="clickable startButton"
         @click="$emit('startSignUp')"
    >
       Commencer maintenant <i class="fa-solid fa-arrow-right-long"></i>
    </div>-->

    </div>
  </div>
</template>

<script>
import {mapGetters} from "vuex";

export default {
  name: "landingPageParagraph",
  props: ['title','imageUrl','imageLeft', 'blue'],

  computed: {
    ...mapGetters('global', [
      'isMobile',
    ]),
  },
}
</script>

<style scoped>
.landingpageParagraph{
  position: relative;
  padding: 3vw 25vw 3vw 25vw;
  min-height: 15vw;
  align-items: center;
  display: flex;
  overflow: hidden;
}

.blueParagraph{
  background-color: var(--navBackgroundColor);
  color: var(--goalBackgroundColor3);
}
.creamParagraph{
  background-color: var(--goalBackgroundColor3);
  color: var(--navBackgroundColor);
}

.landingpageImage{

  position: absolute;
  top: -5vw;
  background-size: cover;
  background-position: top center;
  background-repeat: no-repeat;

  height: 40vw;
  padding-right: 20vw;

  z-index: 5;
}

.landingpageImageLeft{
  left: -5vw;
  border-radius:0 60vw 60vw 0 ;
}

.landingpageImageRight{
  right: -5vw;
  border-radius:60vw 0 0 60vw ;
}

.paragraphContent{
  padding: 2vw;
  position: relative;
}

.startButton{
  align-content: center;
}
.startButton:hover{
  font-weight: bold;
}

@media screen and (max-device-width: 767px) {
  h1{
    font-size: 1.6em;
  }
  .landingpageParagraph{
    padding: 8vw 8vw 8vw 8vw;
    min-height: 30vw;
    width: calc(100% - 16vw);
    max-width: calc(100% - 16vw);
  }

  .paragraphTitle{
    display: flex;
    flex-wrap: wrap;
    align-content: center;
    padding: 0 0 0 38vw;
    height: 32vw;
    width: calc(100% - 35vw);
  }

  .landingpageImage{

    position: absolute;
    top: 4vw;
    background-size: cover;
    background-position: center center;
    background-repeat: no-repeat;

    height: 40vw;
    border-radius: 0 40vw 40vw 40vw;
    padding-right: 40vw;

    z-index: 5;
  }

  .landingpageImageLeft{
    left: 0;
    border-radius: 0 30vw 30vw 0;
  }

  .landingpageImageRight{
    left: 0;
    right: auto;
    border-radius: 30vw 0 0 30vw;
    -webkit-transform: scaleX(-1);
    transform: scaleX(-1);
  }

  .paragraphContent{
    position: relative;
    z-index: 10;
    max-width: 84vw;
    padding: 8vw 0 8vw 0;
  }

  .startButton{
    align-content: center;
  }
  .startButton:hover{
    font-weight: bold;
  }

}
</style>